import { fetch } from '@/utils/http'

export default {
  //Rust合约检测相关====================================================================
  uploadRustContract: params => fetch('post', '/rust_contract_detector/v1/contract/upload', params),
  getRustContractList: params =>
    fetch('get', '/rust_contract_detector/v1/contract/get-list', params),
  getRustContractInfo: params =>
    fetch('get', '/rust_contract_detector/v1/contract/get-info', params),
  deleteRustContract: params =>
    fetch(
      'delete',
      `/rust_contract_detector/v1/contract/delete?contract_id=${params.contract_id}`,
      params
    ),
  addRustDetectTask: params => fetch('put', '/rust_contract_detector/v1/task/start', params),
  restartRustDetectTask: params =>
    fetch('put', `/rust_contract_detector/v1/task/restart?task_id=${params.task_id}`, params),
  getRustDetectTaskList: params => fetch('get', '/rust_contract_detector/v1/task/get-list', params),
  getRustDetectTaskInfo: params => fetch('get', '/rust_contract_detector/v1/task/get-info', params),
  getRustUnfinishedTaskList: params =>
    fetch('get', '/rust_contract_detector/v1/task/get-unfinished', params),
  //====================================================================================
  //Solidity合约检测相关====================================================================
  uploadSolidityContract: params =>
    fetch('post', '/solidity_contract_detector/v1/contract/upload', params),
  modifySolidityContract: params =>
    fetch('put', '/solidity_contract_detector/v1/contract/modify', params),
  getSolidityContractList: params =>
    fetch('get', '/solidity_contract_detector/v1/contract/get-list', params),
  getSolidityContractInfo: params =>
    fetch('get', '/solidity_contract_detector/v1/contract/get-info', params),
  deleteSolidityContract: params =>
    fetch(
      'delete',
      `/solidity_contract_detector/v1/contract/delete?contract_id=${params.contract_id}`,
      params
    ),
  addSolidityDetectTask: params =>
    fetch('put', '/solidity_contract_detector/v1/task/start', params),
  restartSolidityDetectTask: params =>
    fetch('put', `/solidity_contract_detector/v1/task/restart?task_id=${params.task_id}`, params),
  getSolidityDetectTaskList: params =>
    fetch('get', '/solidity_contract_detector/v1/task/get-list', params),
  getSolidityDetectTaskInfo: params =>
    fetch('get', '/solidity_contract_detector/v1/task/get-info', params),
  getSolidityUnfinishedTaskList: params =>
    fetch('get', '/solidity_contract_detector/v1/task/get-unfinished', params),
  getSolidityVersions: params =>
    fetch('get', '/solidity_contract_detector/v1/contract/get-supported-solc-versions', params)
  //====================================================================================
}
